var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-input-container",
    {
      class: {
        "md-input-invalid": _vm.showRequiredError,
        "input-container": _vm.multiple
      }
    },
    [
      _c("label", [_vm._v(_vm._s(_vm.multiple ? "Playlists" : "Playlist"))]),
      _c(
        "md-select",
        {
          attrs: {
            multiple: _vm.multiple,
            disabled: _vm.playLists.length === 0
          },
          on: { selected: _vm.onPlaylistSelected },
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        },
        _vm._l(_vm.playLists, function(playList) {
          return _c(
            "md-option",
            { key: playList._id, attrs: { value: playList._id } },
            [_vm._v(_vm._s(playList.name))]
          )
        }),
        1
      ),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showRequiredError,
              expression: "showRequiredError"
            }
          ],
          staticClass: "md-error"
        },
        [_vm._v("This field is required")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01bfa374", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01bfa374","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/playlist/PlaylistSelector.vue
// module id = 662
// module chunks = 0